import React, { useContext, useState, useEffect } from "react";
import { InputContext } from "../../../shared/contexts/InputContext";
import { OutputContext } from "../../../shared/contexts/OutputContext";
import BarChart from "./BarChart";
import {
  earningsColour,
  preReformLegacyColour,
  preReformRemedyColour,
  postReformLegacyColour,
  postReformRemedyColour,
  defaultChartOptions,
  getMaxScaleValue,
} from "./chartUtils";
import { capitaliseFirstLetter } from "../../../shared/utils/formatters";

const PensionBarChart = ({ retirementType }) => {
  const { inputs } = useContext(InputContext);
  const { outputs, loading } = useContext(OutputContext);
  const [chartData, setChartData] = useState(null);

  const maxScaleValue = getMaxScaleValue(outputs, "income");

  useEffect(() => {
    const graphData = outputs.filter(
      (item) =>
        item.retirementType === retirementType &&
        item.benefitType !== "lump_sum"
    );

    let leftChoice = { earnings: 0, legacy: 0, reform: 0 };
    let rightChoice = { earnings: 0, legacy: 0, reform: 0 };

    graphData.forEach((item) => {
      if (item.benefitType === "earnings") {
        if (item.remedyChoice === "legacy") {
          leftChoice.earnings = item.values.earnings;
        } else if (item.remedyChoice === "reform") {
          rightChoice.earnings = item.values.earnings;
        }
      } else if (item.benefitType === "pension") {
        if (item.remedyChoice === "legacy") {
          leftChoice.legacy = item.values.legacy || 0;
          leftChoice.reform = item.values.reform || 0;
        } else if (item.remedyChoice === "reform") {
          rightChoice.legacy = item.values.legacy || 0;
          rightChoice.reform = item.values.reform || 0;
        }
      }
    });

    setChartData({
      labels: ["Choose Legacy", "Choose alpha"],
      datasets: [
        {
          label: "Earnings",
          data: [leftChoice.earnings, rightChoice.earnings],
          backgroundColor: earningsColour,
          borderRadius: 6,
        },
        {
          label: "Legacy",
          data: [leftChoice.legacy, rightChoice.legacy],
          backgroundColor: [preReformLegacyColour, postReformLegacyColour],
          borderRadius: 6,
        },
        {
          label: "alpha",
          data: [leftChoice.reform, rightChoice.reform],
          backgroundColor: [preReformRemedyColour, postReformRemedyColour],
          borderRadius: 6,
        },
      ],
    });
  }, [inputs, outputs, loading]);

  const handleSegmentClick = (info) => {
    console.log("Segment clicked:", info);
  };

  if (!chartData) return null;

  const chartOptions = {
    ...defaultChartOptions,
    scales: {
      ...defaultChartOptions.scales,
      y: {
        ...defaultChartOptions.scales.y,
        max: maxScaleValue,
      },
    },
    plugins: {
      ...defaultChartOptions.plugins,
      title: {
        ...defaultChartOptions.plugins.title,
        text: `Estimated Income at ${capitaliseFirstLetter(
          retirementType
        )} Retirement`,
      },
      subtitle: {
        ...defaultChartOptions.plugins.subtitle,
        text: `Values are in ${inputs.projectionSettings.realNominalSwitch} terms`,
      },
    },
  };

  return (
    <BarChart
      chartData={chartData}
      chartOptions={chartOptions}
      onSegmentClick={handleSegmentClick}
    />
  );
};

export default PensionBarChart;
